import React from "react"

const steps = ["step1", "step2", "step3", "step4", "step5"]

export class Timer extends React.Component {
    constructor(props) {
        super(props)
        this.id = ""
        this.interval = null
        this.step = 0
        this.model = null
        this.timeOut = null
        this.firstTime = true
    }

    setId = (id) => {
        this.id = id
        this.timeOut = setTimeout(() => {
            this.model.invokeAsync("polling", {
                taskId: this.id,
                createTime: new Date(),
            })
        }, 200)
    }

    setModel = (model) => {
        this.model = model
    }
    start = () => {
        this.interval = setInterval(() => {
            this.model.invokeAsync("polling", {
                taskId: this.id,
                createTime: new Date(),
            })
        }, 3000)
    }

    stop = () => {
        clearInterval(this.interval)
        this.interval = null
        this.step = 0
    }

    setTimer = (id, model) => {
        this.model = model
        this.timeOut = setTimeout(() => {
            model.invokeAsync("polling", {
                taskId: id,
                createTime: new Date(),
            })
        }, 3000)
    }

    generateObj = () => {
        let obj = {}
        for (let i = 0; i < 4; i++) {
            if (i <= this.step) {
                obj[steps[i]] = true
            } else {
                obj[steps[i]] = false
            }
        }
        return obj
    }

    getStep = () => {
        const randomNum = Math.random()
        const step = this.generateObj()
        if (this.firstTime === true) {
            this.firstTime = false
        }
        if (randomNum >= 0.65 && this.step < 3) {
            // if (this.step < 3) {
            this.step++
        }
        this.timeOut = setTimeout(() => {
            this.model.invokeAsync("polling", {
                taskId: this.id,
                createTime: new Date(),
            })
        }, 3000)
        return step
    }

    getActiveStep = () => {
        return this.step
    }

    setStep = () => {
        this.step = 4
    }

    clearTimer = () => {
        clearTimeout(this.timeOut)
    }
}
